import { cn } from "@/lib/utils";

type SunlowerMarkProps = {
  className?: string;
  title?: string;
};

/** ดอกทานตะวันสไตล์กึ่งมินิมอล/การ์ตูน — hero mark ของแบรนด์ */
export function SunlowerMark({
  className,
  title = "Sunlower",
}: SunlowerMarkProps) {
  return (
    <svg
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn("shrink-0", className)}
      role="img"
      aria-label={title}
    >
      {/* ใบไม้คู่ */}
      <path
        d="M18 48c6-4 10-10 12-16-4 2-8 2-12 0-2 6-4 12-0 16Z"
        className="fill-leaf"
      />
      <path
        d="M46 48c-6-4-10-10-12-16 4 2 8 2 12 0 2 6 4 12 0 16Z"
        className="fill-leaf"
      />
      {/* ก้าน */}
      <path
        d="M30 36v14c0 2 2 4 4 4s4-2 4-4V36"
        className="stroke-foreground"
        strokeWidth="2.5"
        strokeLinecap="round"
      />
      {/* กลีบดอก */}
      {[0, 45, 90, 135, 180, 225, 270, 315].map((deg) => (
        <ellipse
          key={deg}
          cx="32"
          cy="22"
          rx="7"
          ry="11"
          className="fill-primary"
          transform={`rotate(${deg} 32 32)`}
        />
      ))}
      {/* ศูนย์กลาง */}
      <circle cx="32" cy="32" r="11" className="fill-secondary" />
      <circle cx="32" cy="32" r="7" className="fill-foreground" />
      <circle cx="29" cy="30" r="1.2" className="fill-primary" />
      <circle cx="35" cy="30" r="1.2" className="fill-primary" />
      <circle cx="32" cy="34" r="1.2" className="fill-primary" />
    </svg>
  );
}
